import MinusIcon from 'Icons/minus.svg?react';
import PlusIcon from 'Icons/plus.svg?react';

interface QuantityInputFieldProps {
    value: number;
    minusAction: () => void;
    plusAction: () => void;
    translations: {
        decrementButton: string;
        incrementButton: string;
        quantityLabel: string;
    };
    minusDisabled?: boolean;
    plusDisabled?: boolean;
    overridePlusDisabled?: boolean;
    showLoweredQuantityWarning?: boolean;
}

const QuantityInputField = ({
    value,
    minusAction,
    plusAction,
    translations,
    minusDisabled,
    plusDisabled,
    overridePlusDisabled,
    showLoweredQuantityWarning,
}: QuantityInputFieldProps) => (
    <div className="flex w-full items-center gap-2 group-[.cs-cart]:w-auto">
        <button
            disabled={minusDisabled}
            type="button"
            onClick={minusAction}
            className={`flex h-5 w-5 items-center justify-center transition-opacity duration-layout group-[.cs-cart]:h-[30px] group-[.cs-cart]:w-[30px] group-[.cs-cart]:p-1.5 ${
                minusDisabled ? 'opacity-50' : ''
            }`}
        >
            <span className="sr-only">{translations.decrementButton}</span>
            <MinusIcon className="h-5 w-5" />
        </button>
        <input
            type="number"
            className={`m-0 h-5 w-5
                p-0 text-center
                text-sm transition-all duration-500
                group-[.cs-cart]:h-[30px] group-[.cs-cart]:w-[30px]
                [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none
                ${
                    showLoweredQuantityWarning
                        ? 'bg-red-500 shadow-[0px_0px_6px_5px_rgb(239,68,68)] shadow-lg'
                        : 'bg-wildSand shadow-none'
                }
            `}
            value={value}
            aria-label={translations.quantityLabel}
            readOnly
        />
        <button
            disabled={plusDisabled && !overridePlusDisabled}
            type="button"
            onClick={plusAction}
            className={`flex h-5 w-5 items-center justify-center transition-opacity duration-layout group-[.cs-cart]:h-[30px] group-[.cs-cart]:w-[30px] group-[.cs-cart]:p-1.5 ${
                plusDisabled ? 'opacity-50' : ''
            }`}
        >
            <span className="sr-only">{translations.incrementButton}</span>
            <PlusIcon className="h-5 w-5" />
        </button>
    </div>
);

export default QuantityInputField;
